"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var components_1 = require("stremio/components");
var common_1 = require("stremio/common");
var subtitleDelay_1 = require("../../subtitleDelay");
var Stepper_less_1 = __importDefault(require("./Stepper.less"));
var clamp = function (value, min, max) {
    var minClamped = typeof min === 'number' ? Math.max(value, min) : value;
    var maxClamped = typeof max === 'number' ? Math.min(minClamped, max) : minClamped;
    return maxClamped;
};
var Stepper = function (_a) {
    var className = _a.className, label = _a.label, value = _a.value, unit = _a.unit, step = _a.step, min = _a.min, max = _a.max, disabled = _a.disabled, _b = _a.accelerate, accelerate = _b === void 0 ? false : _b, onChange = _a.onChange;
    var t = (0, react_i18next_1.useTranslation)().t;
    var localValue = (0, react_1.useRef)(value);
    var holdStartedAt = (0, react_1.useRef)(0);
    var hasRepeated = (0, react_1.useRef)(false);
    var interval = (0, common_1.useInterval)(subtitleDelay_1.SUBTITLES_DELAY_REPEAT_INTERVAL_MS);
    var timeout = (0, common_1.useTimeout)(subtitleDelay_1.SUBTITLES_DELAY_REPEAT_DELAY_MS);
    var cancel = function () {
        interval.cancel();
        timeout.cancel();
    };
    var decreaseDisabled = (0, react_1.useMemo)(function () {
        return disabled || typeof value !== 'number' || (typeof min === 'number' && value <= min);
    }, [disabled, min, value]);
    var increaseDisabled = (0, react_1.useMemo)(function () {
        return disabled || typeof value !== 'number' || (typeof max === 'number' && value >= max);
    }, [disabled, max, value]);
    var valueLabel = (0, react_1.useMemo)(function () {
        return (disabled || typeof value !== 'number') ? '--' : "".concat(value).concat(unit);
    }, [disabled, value, unit]);
    var updateValue = (0, react_1.useCallback)(function (delta) {
        onChange(clamp(localValue.current + delta, min, max));
    }, [max, min, onChange]);
    var startRepeating = (0, react_1.useCallback)(function (direction) {
        cancel();
        holdStartedAt.current = performance.now();
        hasRepeated.current = false;
        var repeatValue = localValue.current;
        timeout.start(function () { return interval.start(function () {
            if (!accelerate) {
                updateValue(direction * step);
                return;
            }
            hasRepeated.current = true;
            var heldFor = performance.now() - holdStartedAt.current;
            var multiplier = (0, subtitleDelay_1.getSubtitleDelayStepMultiplier)(heldFor);
            repeatValue = clamp(repeatValue + direction * step * multiplier, min, max);
            onChange(repeatValue);
        }); });
    }, [accelerate, max, min, onChange, step, updateValue]);
    var onDecrementMouseDown = (0, react_1.useCallback)(function () {
        startRepeating(-1);
    }, [startRepeating]);
    var onDecrementMouseUp = (0, react_1.useCallback)(function () {
        cancel();
        if (!accelerate || !hasRepeated.current)
            updateValue(-step);
    }, [accelerate, step, updateValue]);
    var onIncrementMouseDown = (0, react_1.useCallback)(function () {
        startRepeating(1);
    }, [startRepeating]);
    var onIncrementMouseUp = (0, react_1.useCallback)(function () {
        cancel();
        if (!accelerate || !hasRepeated.current)
            updateValue(step);
    }, [accelerate, step, updateValue]);
    (0, react_1.useEffect)(function () {
        localValue.current = value;
    }, [value]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(Stepper_less_1.default['stepper'], className) },
        react_1.default.createElement("div", { className: Stepper_less_1.default['header'] }, t(label)),
        react_1.default.createElement("div", { className: Stepper_less_1.default['content'] },
            react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(Stepper_less_1.default['button'], { 'disabled': decreaseDisabled }), onMouseDown: onDecrementMouseDown, onMouseUp: onDecrementMouseUp, onMouseLeave: cancel },
                react_1.default.createElement(react_2.default, { className: Stepper_less_1.default['icon'], name: 'remove' })),
            react_1.default.createElement("div", { className: Stepper_less_1.default['value'] }, valueLabel),
            react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(Stepper_less_1.default['button'], { 'disabled': increaseDisabled }), onMouseDown: onIncrementMouseDown, onMouseUp: onIncrementMouseUp, onMouseLeave: cancel },
                react_1.default.createElement(react_2.default, { className: Stepper_less_1.default['icon'], name: 'add' })))));
};
exports.default = Stepper;
